import {HttpEvent, HttpHandlerFn, HttpInterceptorFn} from '@angular/common/http';
import { inject } from '@angular/core';
import { HttpRequest } from '@angular/common/http';

import { Observable } from 'rxjs';
import {TokenStorageService} from "../services/token.storage.service";
import {Router} from "@angular/router";

const TOKEN_HEADER_KEY = 'Authorization';



export const authInterceptor: HttpInterceptorFn = (
    req: HttpRequest<any>,
    next: HttpHandlerFn
): Observable<HttpEvent<any>> => {
  const tokenStorageService = inject(TokenStorageService);
  const router = inject(Router);
  const token = tokenStorageService.getToken();
  if (token) {
    const cloned = req.clone(
        { headers: req.headers.set(TOKEN_HEADER_KEY, 'Bearer ' + token) }
    );
    return next(cloned);
  } else {
    // router.navigate(['/login']).then();
    return next(req);
  }
};




